<script setup>
import { computed } from 'vue';

const emit = defineEmits(['proceed']);

const props = defineProps({
  // 遷移先コンテキスト 'cart'（カートへ移動） / 'back'（前画面へ戻る）
  leaveTo: {
    type: String,
    default: 'cart'
  }
});

// 主ボタン文言（遷移先コンテキストにより出し分け）
const proceedLabel = computed(() => {
  return props.leaveTo === 'back' ? '追加せず前画面へ戻る' : '追加せずカートへ';
});
</script>

<template>
  <div class="modal com_modal2 fade" id="discontinuedLeaveConfirmModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <img src="/front/assets/common/img/icon_attention1.png" alt="" class="icon_attention1">
          <h3 class="com_fs18 com_strong1 com_center1 com_mgb0 com_lh1">取扱中止品はカートに<br>いれることができません。</h3>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn com_app_btn1" data-bs-dismiss="modal" @click="emit('proceed')">{{ proceedLabel }}</button>
          <button type="button" class="btn com_app_btn2" data-bs-dismiss="modal">戻る</button>
        </div>
      </div>
    </div>
  </div>
</template>
